import { Dto, DtoWithId } from "@mango/core";
import { Pakbon } from './pakbon';
import { Projectregel } from "./projectregel";

@Dto({fullName: "CIJBorculo.Logic.Pakbonregel"})
export class Pakbonregel extends DtoWithId {
	pakbon: Pakbon;
	projectregel: Projectregel;
	oldId: number;
}